import module from 'finanzas/module.js'

function ComisionistasService ($api, $export) {
  this.obtenerComisionistas = function () {
    return $api.get('kendu/finanzas/comisionistas/obtenerComisionistas')
  }

  this.obtenerReporte = function (start, end, ids_comisionistas) {
    return $api.get('kendu/finanzas/comisionistas/obtenerReporte', {
      start: start.toYMD(),
      end: end.toYMD(),
      ids_comisionistas: ids_comisionistas,
    })
  }

  this.exportarXLS = function (data, archivo) {
    var referencias = []
    data.forEach(function (item) {
      if (referencias.indexOf(item.ID_Comisionista) === -1) {
        referencias.push(item.ID_Comisionista)
      }
    })

    var pages = [],
      aux = [],
      datos = [],
      encabezados = [],
      nombre
    referencias.forEach(function (referencia) {
      data.map(function (item) {
        if (item.ID_Comisionista === referencia) {
          nombre = item.Nombre.substr(0, 31)
          aux = [
            // item.Nombre,
            item.Descripcion,
            item.Num_Operaciones,
            item.Nom_Esquema,
            item.Comision_Porcentaje,
          ]
          item.Facturacion.map(function (elemento) {
            aux.push(elemento.valor)
          })
          datos.push(aux)
        }
      })
      encabezados = [
        // {label: "Comisionista", format: {align: "left", width: 30}},
        {
          label: 'Empresa',
          format: {
            align: 'left',
            width: 40,
          },
        }, {
          label: 'Número de Op.',
          format: {
            align: 'right',
            width: 20,
          },
        }, {
          label: 'Nombre',
          format: {
            align: 'center',
            width: 20,
          },
        }, {
          label: 'Comisión',
          format: {
            type: 'percent',
            align: 'center',
            width: 20,
          },
        },
      ];
      data[0].Facturacion.map(function (elemento) {
        encabezados.push({
          label: elemento.mes + ' ' + elemento.anio,
          format: {
            type: 'currency',
            align: 'right',
            width: 12,
          },
        });
      });

      pages.push(new Page(datos, encabezados, nombre));
      nombre = '';
      aux = [];
      datos = [];
      encabezados = [];
    });

    $export.excel(archivo, pages);
  }

  function Page (data, encabezados, nombre) {
    // columanas = generarColumnas
    return {
      name: nombre,
      columns: encabezados,
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
      data: data,
    };
  }
}

module.service('Comisionistas', ComisionistasService)



// WEBPACK FOOTER //
// ./src/finanzas/_/comisionistas/Comisionistas.js